import { PACKAGE, PCB_CHANNEL_CREATE } from "../../../constants/treeConstants";
import { isPackagePCB } from "../helper/publicHelper";
import { PROJECTS_INDEX, DESIGN_INDEX, PACKAGE_INDEX } from "../index";
import { addChannelAction } from "../project";

/* add channelList to treeItem by designId ,projectId */
function channelListToTree({ _treeItems, projectId, designId, channels, designType }) {
  const design_Index = designType === PACKAGE ? PACKAGE_INDEX : DESIGN_INDEX;
  const { projectIndex, designIndex } = getIndex({ _treeItems, projectId, designId, design_Index });
  if (designIndex < 0 || projectIndex < 0) {
    return _treeItems;
  }

  const createChannelItem = _treeItems[PROJECTS_INDEX].children[projectIndex].children[design_Index].children[designIndex].children.find(item => item.dataType === PCB_CHANNEL_CREATE);
  _treeItems[PROJECTS_INDEX].children[projectIndex].children[design_Index].children[designIndex].children = [
    ...channels,
    new addChannelAction(designId),
    ...(createChannelItem ? [createChannelItem] : [])
  ];
  return _treeItems;
}

/* get project index and design index of treeItem */
function getIndex({ _treeItems, projectId, designId, design_Index }) {
  const projectIndex = _treeItems[PROJECTS_INDEX].children.findIndex(item => item.id === projectId);

  if (projectIndex < 0) {
    return { projectIndex, designIndex: -1 }
  }

  const designIndex = _treeItems[PROJECTS_INDEX].children[projectIndex].children[design_Index].children.findIndex(item => item.id === designId);

  return { projectIndex, designIndex }
}

function cancelCreateChannel(treeItems, openProjectId, itemData) {
  const _treeItems = [...treeItems];
  const design_Index = isPackagePCB(itemData.designId) ? PACKAGE_INDEX : DESIGN_INDEX;
  const { projectIndex, designIndex } = getIndex({ _treeItems, projectId: openProjectId, designId: itemData.designId, design_Index });
  if (designIndex > -1) {
    const pcbChildren = _treeItems[PROJECTS_INDEX].children[projectIndex].children[design_Index].children[designIndex].children.filter((item) => item.dataType !== PCB_CHANNEL_CREATE)
    _treeItems[PROJECTS_INDEX].children[projectIndex].children[design_Index].children[designIndex].children = pcbChildren;
    return _treeItems;
  }
}

export {
  channelListToTree,
  getIndex,
  cancelCreateChannel
}